export default __webpack_public_path__ + "images/f0974769d6cdd34e7b31a1a9ed60087f-increase-movement.svg";